import {
  QUERY_CONFIGS,
  QueryConfigKeys,
} from '@hub/utils/react-query/query-config';
import { fetchCurrencies } from '@hub/utils/react-query/query-functions';
import { QUERY_KEYS } from '@hub/utils/react-query/query-keys';
import { ExtractFnReturnType } from '@hub/utils/react-query/react-query';
import { useQuery } from '@tanstack/react-query';

const CONFIG_KEY = QueryConfigKeys.CURRENCIES;

export const useCurrencies = () => {
  return useQuery<ExtractFnReturnType<typeof fetchCurrencies>>({
    queryKey: QUERY_KEYS[QueryConfigKeys.CURRENCIES].LIST,
    queryFn: fetchCurrencies,
    staleTime: QUERY_CONFIGS[CONFIG_KEY].staleTime,
  });
};
